import React, { useEffect, useRef, useState } from "react";
import Checkbox from "shared/Checkbox";
import { DropdownWrap, Menu, MenuItem, Input, MenuType1, Column, MenuInner } from "shared/Dropdown/styled";

const Dropdown = ({
  items,
  placeholder,
  reff,
  name,
  error,
  setValues,
  isDropdownCheckbox,
  defaultValue = "",
  disabled,
}) => {
  const [isShowMenu, toggleMenu] = useState(false);
  const [value, setValue] = useState("");
  const [checked, setChecked] = useState([]);

  const wrapper = useRef();

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    window.addEventListener("click", hideDropdown);
    return () => {
      window.removeEventListener("click", hideDropdown);
    };
  }, []);

  const toggleCheckbox = (item) => {
    if (checked.includes(item)) {
      const filtredCheked = checked.filter((checkbox) => checkbox !== item);
      setChecked(filtredCheked);
    } else setChecked([...checked, item]);
  };

  const hideDropdown = (e) => {
    if (wrapper.current && !wrapper.current.contains(e.target)) {
      toggleMenu(false);
    }
  };

  const handleClick = () => {
    toggleMenu(!isShowMenu);
  };

  const chooseMenuItem = (e, item) => {
    if (!setValues) {
      setValue(e.target.id);
      toggleMenu(false);
    } else {
      setValues(name, e.target.id, item);
      setValue(e.target.id);
      toggleMenu(false);
    }
  };

  return (
    <>
      <Column className="column">
        <DropdownWrap
          ref={wrapper}
          error={error}
          isShowMenuType1={isShowMenu}
          isDropdownCheckbox={isDropdownCheckbox}
          isShowMenu={isShowMenu}
          isHaveValue={checked}
          disabled={disabled}
        >
          <Input
            ref={reff}
            name={name}
            readOnly
            value={value || checked.join(", ")}
            placeholder={placeholder}
            onClick={handleClick}
          />
          {isShowMenu && !disabled && (
            <>
              {isDropdownCheckbox ? (
                <MenuType1 isDropdownCheckbox={isDropdownCheckbox}>
                  <MenuInner>
                    {items.map((item) => {
                      return (
                        <MenuItem key={item}>
                          <Checkbox
                            checked={checked.includes(item)}
                            onChange={() => toggleCheckbox(item)}
                            text={item}
                          />
                        </MenuItem>
                      );
                    })}
                  </MenuInner>
                </MenuType1>
              ) : (
                <Menu className="scrollBar">
                  {items.map((item) => {
                    if (item.name)
                      return (
                        <MenuItem key={item.id} id={item.name} onClick={(e) => chooseMenuItem(e, item)}>
                          {item.name}
                        </MenuItem>
                      );
                    else
                      return (
                        <MenuItem key={item} id={item} onClick={chooseMenuItem}>
                          {item}
                        </MenuItem>
                      );
                  })}
                </Menu>
              )}
            </>
          )}
        </DropdownWrap>
      </Column>
    </>
  );
};

export default Dropdown;
